import Default from "./GroupedExpandable";
import GroupedExpandableProps from "./GroupedExpandable";
export * from "./GroupedExpandable";

export default Default;